import actions from 'src/modules/resource/inlineEdit/resourceInlineEditActions';

type SaveStatus = 'idle' | 'saving' | 'saved' | 'error';

type State = {
  saveStatus: SaveStatus;
  savedAt: number | null;
  error: string | null;
  readMode: boolean;
};

const initialData: State = {
  saveStatus: 'idle',
  savedAt: null,
  error: null,
  readMode: false,
};

type Action = {
  type: string;
  payload?: {
    readMode?: boolean;
    savedAt?: number;
    error?: string | null;
  };
};

export default (
  state: State = initialData,
  { type, payload }: Action,
): State => {
  if (type === actions.SAVE_STARTED) {
    return {
      ...state,
      saveStatus: 'saving',
      error: null,
    };
  }

  if (type === actions.SAVE_SUCCESS) {
    return {
      ...state,
      saveStatus: 'saved',
      savedAt: payload?.savedAt ?? Date.now(),
      error: null,
    };
  }

  if (type === actions.SAVE_ERROR) {
    return {
      ...state,
      saveStatus: 'error',
      error: payload?.error ?? null,
    };
  }

  if (type === actions.SAVE_IDLE) {
    return {
      ...state,
      saveStatus: 'idle',
      error: null,
    };
  }

  if (
    type === actions.READ_MODE_TOGGLED ||
    type === actions.READ_MODE_HYDRATED
  ) {
    return {
      ...state,
      readMode: Boolean(payload?.readMode),
    };
  }

  return state;
};
